import { NavLink, useLocation, matchPath } from 'react-router-dom';
import { config } from '../../config';
import { formatCounter } from '../../utils/formatCounter';
import { useChat } from '../../context/ChatProvider';
import { useNotifications } from '../../context/NotificationContext';

const SHOW_NAV_ROUTES = [
  config.ROUTES.MEET,
  config.ROUTES.ROULETTE,
  config.ROUTES.STREAMS.LIST,
  config.ROUTES.CHATS.LIST,
  config.ROUTES.LIKES,
  config.ROUTES.EVENTS.LIST
];

const navigationConfig = [
  {
    href: config.ROUTES.MEET,
    icon: ({ isActive }) => {
      return (
        <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.97559 5.83496C10.3497 4.48307 11.7487 3.69053 13.1006 4.06445L21.2607 6.32227C22.6126 6.69632 23.406 8.09538 23.0322 9.44727L18.9678 24.1367C18.5935 25.4885 17.1937 26.2813 15.8418 25.9072L7.68164 23.6494C6.32968 23.2753 5.53704 21.8754 5.91113 20.5234L9.97559 5.83496ZM12.0068 0C13.4097 0 14.5469 1.13719 14.5469 2.54004V2.70703L13.5527 2.43262C11.2994 1.80921 8.96726 3.13045 8.34375 5.38379L4.2793 20.0713C4.25638 20.1541 4.23646 20.2374 4.21875 20.3203H3.54004C2.13741 20.3201 1.00009 19.1829 1 17.7803V2.54004C1 1.13731 2.13735 0.000189959 3.54004 0H12.0068Z"
            fill={isActive ? '#A1F69E' : '#fff'}
          />
        </svg>
      );
    }
  },
  {
    href: config.ROUTES.LIKES,
    badge: 'likes',
    icon: ({ isActive }) => {
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2141_20684)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.89795 1.85972C8.57885 1.98152 10.3304 2.80091 12.007 4.45926C13.6832 2.80138 15.4332 1.98354 17.1125 1.86445C19.0078 1.73003 20.6834 2.49606 21.8957 3.70465C24.2791 6.08089 25.0275 10.3807 22.0701 13.3383C22.0601 13.3482 22.0498 13.358 22.0394 13.3674L12.5824 21.9336C12.2558 22.2293 11.7582 22.2293 11.4316 21.9336L1.97457 13.3674C1.96411 13.358 1.9539 13.3482 1.94392 13.3383C-1.02905 10.3653 -0.284582 6.06498 2.10667 3.69059C3.32191 2.48391 5.00087 1.72227 6.89795 1.85972Z"
              fill={isActive ? '#A1F69E' : '#fff'}
            />
          </g>
          <defs>
            <clipPath id="clip0_2141_20684">
              <rect width="24" height="24" fill={isActive ? '#A1F69E' : '#fff'} />
            </clipPath>
          </defs>
        </svg>
      );
    }
  },
  {
    href: config.ROUTES.EVENTS.LIST,
    icon: ({ isActive }) => {
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M22.5 13.5H18C16.8065 13.5 15.6619 13.9741 14.818 14.818C13.9741 15.6619 13.5 16.8065 13.5 18V22.5H4.5C3.70435 22.5 2.94129 22.1839 2.37868 21.6213C1.81607 21.0587 1.5 20.2956 1.5 19.5V10.5H22.5V13.5Z"
            fill={isActive ? '#A1F69E' : '#fff'}
          />
          <path
            d="M15 22.5V18C15 17.2044 15.3161 16.4413 15.8787 15.8787C16.4413 15.3161 17.2044 15 18 15H22.5L15 22.5ZM18 1.5C18.3978 1.5 18.7794 1.65804 19.0607 1.93934C19.342 2.22064 19.5 2.60218 19.5 3V4.5C20.2956 4.5 21.0587 4.81607 21.6213 5.37868C22.1839 5.94129 22.5 6.70435 22.5 7.5V9H1.5V7.5C1.5 6.70435 1.81607 5.94129 2.37868 5.37868C2.94129 4.81607 3.70435 4.5 4.5 4.5V3C4.5 2.60218 4.65804 2.22064 4.93934 1.93934C5.22064 1.65804 5.60218 1.5 6 1.5C6.39782 1.5 6.77936 1.65804 7.06066 1.93934C7.34196 2.22064 7.5 2.60218 7.5 3V4.5H16.5V3C16.5 2.60218 16.658 2.22064 16.9393 1.93934C17.2206 1.65804 17.6022 1.5 18 1.5Z"
            fill={isActive ? '#A1F69E' : '#fff'}
          />
        </svg>
      );
    }
  },
  {
    href: config.ROUTES.CHATS.LIST,
    icon: ({ isActive }) => {
      return (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2093_2132)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.4964 0.08008C14.2903 0.0790609 16.0614 0.482939 17.6775 1.26161C19.2937 2.04032 20.7133 3.17379 21.8303 4.5775C22.9475 5.9812 23.7333 7.61896 24.1295 9.36868C24.5255 11.1184 24.5216 12.935 24.1179 14.683C23.7141 16.4309 22.9211 18.0653 21.7979 19.4641C20.6747 20.863 19.2501 21.9901 17.6306 22.7619C16.011 23.5335 14.2382 23.9297 12.4442 23.9207C10.7455 23.9123 9.06934 23.541 7.52765 22.8329L1.58597 23.9072C1.28239 23.9621 0.972736 23.8496 0.775161 23.6127C0.577585 23.3758 0.52257 23.0509 0.631108 22.7622L2.3355 18.2276C1.28919 16.5196 0.688813 14.5733 0.593258 12.5678C0.490636 10.414 0.974131 8.27272 1.99225 6.37199C3.01037 4.47126 4.52497 2.88227 6.37475 1.77428C8.22445 0.666313 10.3403 0.0807985 12.4964 0.08008ZM9.07139 12.0005C9.07139 12.9472 8.30387 13.7147 7.35711 13.7147C6.41034 13.7147 5.64282 12.9472 5.64282 12.0005C5.64282 11.0537 6.41034 10.2862 7.35711 10.2862C8.30387 10.2862 9.07139 11.0537 9.07139 12.0005ZM12.5 13.7147C13.4467 13.7147 14.2143 12.9472 14.2143 12.0005C14.2143 11.0537 13.4467 10.2862 12.5 10.2862C11.5532 10.2862 10.7857 11.0537 10.7857 12.0005C10.7857 12.9472 11.5532 13.7147 12.5 13.7147ZM17.6428 13.7147C18.5896 13.7147 19.3571 12.9472 19.3571 12.0005C19.3571 11.0537 18.5896 10.2862 17.6428 10.2862C16.6961 10.2862 15.9285 11.0537 15.9285 12.0005C15.9285 12.9472 16.6961 13.7147 17.6428 13.7147Z"
              fill={isActive ? '#A1F69E' : '#fff'}
            />
          </g>
          <defs>
            <clipPath id="clip0_2093_2132">
              <rect width="24" height="24" fill="white" transform="translate(0.5)" />
            </clipPath>
          </defs>
        </svg>
      );
    },
    badge: 'chats'
  },
  {
    href: config.ROUTES.PROFILE_MENU,
    icon: ({ isActive }) => {
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.0001 0.978516C10.671 0.978516 9.39638 1.50648 8.4566 2.44627C7.51681 3.38605 6.98885 4.66067 6.98885 5.98973C6.98885 7.31879 7.51681 8.59341 8.4566 9.53319C9.39638 10.473 10.671 11.0009 12.0001 11.0009C13.3291 11.0009 14.6037 10.473 15.5435 9.53319C16.4833 8.59341 17.0113 7.31879 17.0113 5.98973C17.0113 4.66067 16.4833 3.38605 15.5435 2.44627C14.6037 1.50648 13.3291 0.978516 12.0001 0.978516ZM6.65477 13.6736C5.32571 13.6736 4.05109 14.2016 3.11131 15.1413C2.17152 16.0811 1.64355 17.3557 1.64355 18.6848V20.2724C1.64355 21.2799 2.37319 22.1379 3.36741 22.2996C9.0842 23.2336 14.9159 23.2336 20.6327 22.2996C21.1135 22.2205 21.5507 21.9733 21.8664 21.6021C22.1821 21.2308 22.3558 20.7596 22.3566 20.2724V18.6848C22.3566 17.3557 21.8286 16.0811 20.8888 15.1413C19.949 14.2016 18.6744 13.6736 17.3454 13.6736H16.891C16.6416 13.6745 16.3992 13.7128 16.164 13.7885L15.0068 14.1667C13.053 14.8045 10.9471 14.8045 8.99333 14.1667L7.83608 13.7885C7.60151 13.7133 7.35679 13.6745 7.11045 13.6736H6.65477Z"
            fill={isActive ? '#A1F69E' : '#fff'}
          />
        </svg>
      );
    }
  }
];

export const Navigation = () => {
  const location = useLocation();
  const { totalUnread } = useChat();
  const { counts } = useNotifications();

  // Непросмотренные лайки/симпатии/суперлайки — числом карточек на /likes
  // (уникальные пользователи, а не сырые уведомления)
  const likesUnseen = counts.likes || 0;

  const hideNavigation = !SHOW_NAV_ROUTES.some((route) => matchPath(route, location.pathname));

  if (hideNavigation) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[10] flex justify-center px-2">
      <div className="mb-4 w-full max-w-[420px] bg-[#1C3E3E] flex items-center justify-between rounded-full p-[3px]">
        {navigationConfig.map((n) => (
          <NavLink
            key={n.href}
            to={n.href}
            className={({ isActive }) =>
              `relative flex-1 min-w-0 aspect-square max-w-[64px] max-h-[64px] rounded-full flex justify-center items-center ${
                isActive ? 'bg-white/10' : 'bg-transparent'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <n.icon isActive={isActive} />

                {n.badge === 'chats' && totalUnread > 0 && (
                  <div className="absolute top-[8%] right-[8%] min-w-[20px] h-[20px] px-[3px] bg-[#A1F69E] text-black text-xs font-bold border-4 border-[#1C3D3D] rounded-full flex items-center justify-center">
                    {formatCounter(totalUnread)}
                  </div>
                )}

                {n.badge === 'likes' && likesUnseen > 0 && (
                  <div className="absolute top-[8%] right-[8%] min-w-[22px] h-[22px] px-[3px] bg-[#A1F69E] text-black text-xs font-bold border-[2.5px] border-[#1C3D3D] rounded-full flex items-center justify-center">
                    {formatCounter(likesUnseen)}
                  </div>
                )}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </div>
  );
};
